export default __webpack_public_path__ + "static/media/website-icon.a9404a2b.svg";